// extracted by mini-css-extract-plugin
export default {"container":"HomeWrapper_container__2isv6","footer":"HomeWrapper_footer__Tcvrc","social":"HomeWrapper_social__nOefB"};